// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__T0WVT","Logout":"Navigation_Logout__RfLjy"};